import React from 'react';
import PropTypes from 'prop-types';
import ToolBreadcrumbs from '../components/breadcrumbs';
import Header from '../components/header';
import Stackups from '../components/stackups';
import glamorous from 'glamorous';
import {Spinner} from '../components/spinner';
import Circular, {LARGE} from '../../../shared/library/indicators/indeterminate/circular';
import {PAGE_WIDTH} from '../../../shared/style/dimensions';
import {ASH} from '../../../shared/style/colors';

const Page = glamorous.div({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column'
});

const TopContent = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  width: PAGE_WIDTH,
  height: '100%',
  paddingBottom: 45
});

const Divider = glamorous.div({
  borderBottom: `2px solid ${ASH}`,
  width: '100%'
});

const Content = glamorous.main({
  display: 'flex',
  flexDirection: 'column',
  width: PAGE_WIDTH,
  height: '100%'
});

const ToolStackups = ({tool, loading}) => {
  if (loading) {
    return (
      <Spinner>
        <Circular size={LARGE} />
      </Spinner>
    );
  }
  if (tool) {
    return (
      <Page>
        <TopContent>
          <ToolBreadcrumbs tool={tool} />
          <Header logo={tool.imageUrl} title={tool.name} website={tool.websiteUrl} />
        </TopContent>
        <Divider />
        <Content>
          <Stackups tool={tool} />
        </Content>
      </Page>
    );
  }
  return null;
};

ToolStackups.propTypes = {
  tool: PropTypes.object,
  loading: PropTypes.bool
};

export default ToolStackups;
